import React from "react";
// import image from "../../static/images/mobile-home.jpg";
import image from "../../static/images/logo.jpg";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ButtonComponent from "../../components/form-component/ButtonComponent";
import { Logout } from "../../services/graphql/queries/auth";
import { loginAction } from "../../services/redux/actions/loginActions";
import config from "../../config";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
  }

  componentWillReceiveProps(prevProps) {
    if (prevProps.permission !== this.props.permission) {
      this.setState({
        loading: false,
      });
    }
  }

  componentDidUpdate() {
    const permission = this.props.permission;
    if (this.state.loading && Object.keys(permission).length) {
      this.setState({
        loading: false,
      });
    }
  }

  logout = () => {
    const commonLogin = localStorage.getItem("commonLogin");
    this.props.client
      .mutate({
        mutation: Logout,
        variables: { logoutBy: 1 },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        console.log("result@@", result.data.logout.message);
        localStorage.clear();

        this.props.dispatch(loginAction());
        if (commonLogin) {
          window.open(config.COMMON_LOGIN_URL, "_self");
        } else {
          this.props.history.push("/mobile-login");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const permission = this.props.permission;
    if (this.state.loading) {
      return (
        <div class="main-section pt-0 pl-0 pr-0 pb-0">
          <div class="container-fluid">
            <span>Loading...</span>
          </div>
        </div>
      );
    }
    return (
      <div class="main-section pt-0 pl-0 pr-0">
        <div class="container-fluid">
          {Object.keys(permission).length !== 0 ? (
            <div class="row center">
              <div class="col-lg-12 text-center">
                <h1 className="application-heading mt-5">Document Management System</h1>
              </div>
            </div>
          ) : (
            <div className="center">
              <h3 className="text-center">
                You do not have access to Document Management System. Kindly contact
                Administrator for further information.
              </h3>
              <div className="text-center">
                <ButtonComponent
                  type="submit"
                  className="btn-danger mt-4"
                  title="Close"
                  onClick={() => {
                    this.logout();
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  permission: state.auth.permission,
});

export default connect(mapStateToProps)(withRouter(withApollo(Home)));
